module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門6_5_5.6794b3d8.png";